export default "__VITE_ASSET__BnzeTGis__"